export default __webpack_public_path__ + "static/media/t19.min.37fb964d.png";